export default "__VITE_ASSET__D29gRZWL__"